/**
 * Modales globales del POS (cerrarModal).
 */

export function attachModalUtilsGlobals(win, $) {
	win.posknPedirCodigo = function posknPedirCodigo(titulo) {
		return new Promise((resolve) => {
			const modal = document.getElementById('modal-codigo-seguridad');
			const input = document.getElementById('modal-codigo-input');
			const errorEl = document.getElementById('modal-codigo-error');
			const tituloEl = document.getElementById('modal-codigo-titulo');
			const btnAceptar = document.getElementById('modal-codigo-aceptar');
			const btnCancelar = document.getElementById('modal-codigo-cancelar');
			if (!modal || !input || !btnAceptar || !btnCancelar) {
				resolve(false);
				return;
			}
			if (tituloEl) tituloEl.textContent = titulo || 'Ingrese el código de seguridad';
			input.value = '';
			if (errorEl) errorEl.textContent = '';
			modal.style.display = 'flex';
			setTimeout(() => input.focus(), 100);

			function limpiar() {
				btnAceptar.removeEventListener('click', onAceptar);
				btnCancelar.removeEventListener('click', onCancelar);
				input.removeEventListener('keydown', onKey);
				modal.style.display = 'none';
			}
			function onAceptar() {
				const val = (input.value || '').trim();
				const esperado = (win.posknCodigoLimpiar || '').trim();
				if (val !== '' && val === esperado) {
					limpiar();
					resolve(val);
				} else if (errorEl) {
					errorEl.textContent = 'Código incorrecto';
					input.value = '';
					input.focus();
				}
			}
			function onCancelar() {
				limpiar();
				resolve(false);
			}
			function onKey(e) {
				if (e.key === 'Enter') onAceptar();
				if (e.key === 'Escape') onCancelar();
			}
			btnAceptar.addEventListener('click', onAceptar);
			btnCancelar.addEventListener('click', onCancelar);
			input.addEventListener('keydown', onKey);
		});
	};

	win.cerrarModal = function cerrarModal(modalId) {
		if (modalId === 'modal-pago' && win.procesandoPedido && typeof win.posknAbortarEnvioPedidoActivo === 'function') {
			win.posknAbortarEnvioPedidoActivo('Envío cancelado.');
		}
		$(`#${modalId}`).hide();

		if (modalId === 'modal-producto') {
			win._posknCknFichaToken = (win._posknCknFichaToken || 0) + 1;
			win.productoActual = null;
			$('#modal-cantidad').val('');
			$('#modal-notas').val('');
			$('#modal-variaciones').hide();
			$('#modal-ckn-precios').hide().empty();

			setTimeout(() => {
				if (typeof win.limpiarBusquedaProductos === 'function') {
					win.limpiarBusquedaProductos(true, $('#category-select').val());
				} else {
					$('#buscar-productos').val('').focus();
					if (typeof win.productosVisiblesList !== 'undefined') win.productosVisiblesList = [];
					if (typeof win.indiceSeleccionado !== 'undefined') win.indiceSeleccionado = -1;
					$('.producto-card').show().css({
						border: '1px solid #e0e0e0',
						'box-shadow': 'none',
						'background-color': '',
					}).removeClass('producto-seleccionado');
					if (typeof win.mostrarSoloCategoria === 'function') {
						win.mostrarSoloCategoria($('#category-select').val());
					}
				}
			}, 100);
		}
	};
}
